module.exports = __webpack_public_path__ + "img/110.10.1bb4f0ef.png";